import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FindInPageIcon from "@mui/icons-material/FindInPage";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { TreeParameters } from "../../../models/tree/TreeParameter";
type Props = {
	setLocationId: (id: number) => void;
	setShowModal: (modal: "NEW" | "EDIT" | "DELETE" | "VIEW" | "") => void;
};
export const useLocationOptionsFunctions = ({
	setLocationId,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: TreeParameters) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Location",
				key: "new_location",
				onClick: () => {
					setShowModal("NEW");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			options = options.concat([
				{
					name: "Edit Location",
					key: "edit_location",
					onClick: () => {
						setLocationId(data.id);
						setShowModal("EDIT");
					},
					icon: <EditIcon />,
				},
				{
					name: "View Location",
					key: "view_location",
					onClick: () => {
						setLocationId(data.id);
						setShowModal("VIEW");
					},
					icon: <FindInPageIcon />,
				},
			]);
			if (!data.droppable) {
				options = options.concat([
					{
						name: "Delete Location",
						key: "delete_location",
						onClick: () => {
							setLocationId(data.id);
							setShowModal("DELETE");
						},
						icon: <DeleteIcon />,
					},
				]);
			}
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
